import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** Upload Regions Base */
export const useFlagrouteUploadTenant = (): boolean => useINTERNALFlag('route-upload-tenant');
/** Upload Regions Base */
export const FlagrouteUploadTenant = (props: PropsNoName) => <INTERNALFlag name="route-upload-tenant" {...props}/>
